// ─── useLogout.js ─────────────────────────────────────────────────────────────
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { showSuccess } from "utils/notifications";

const useLogout = (showMessage = true) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    const accessToken  = localStorage.getItem("accessToken");
    const csrfToken    = localStorage.getItem("csrfToken");
    const refreshToken = localStorage.getItem("refreshToken");

    // ── Backend logout ────────────────────────────────────────────────────────
    // Backend requires ALL THREE: Authorization header, x-csrf-token header,
    // and refreshToken in body. If any is missing, backend returns 400/401.
    // We only attempt the call when all three are present.
    if (accessToken && csrfToken && refreshToken) {
      try {
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/auth/logout`,
          { refreshToken },                          // required by logoutUser → req.body.refreshToken
          {
            headers: {
              Authorization: `Bearer ${accessToken}`, // required → jwt.verify(accessToken)
              "X-CSRF-Token": csrfToken,              // required → logoutModel session lookup
            },
          }
        );
      } catch (err) {
        // Non-critical: client state is always cleared below.
        // Backend may return 401 if token already expired — that's fine.
        console.warn("Backend logout failed (session may already be expired):", err?.response?.data?.message || err.message);
      }
    } else {
      console.warn("Skipping backend logout — one or more tokens missing.");
    }

    // ── Always clear client state ─────────────────────────────────────────────
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("csrfToken");
    localStorage.removeItem("user");

    dispatch({ type: "REMOVE_TOKEN" });
    dispatch({ type: "LOGOUT_USER" });
    dispatch({ type: "REMOVE_MENUACCESS" });
    dispatch({ type: "REMOVE_MENULIST" });

    if (showMessage) showSuccess("Logout successful.");

    navigate("/admin/signin", { replace: true });
  }, [dispatch, navigate, showMessage]);

  return logout;
};

export default useLogout;